// extracted by extract-css-chunks-webpack-plugin
module.exports = {"load__btn":"load__btn_Etbtr","ui_mask":"ui_mask_dFs37"};